module.exports = __webpack_public_path__ + "img/cate_product6.12e15f0c.png";